import MitLandingPage from '../pages/MitLandingPage.vue';

import MitMyAccountPage from '../pages/MitMyAccountPage.vue';
import MitPasswordChangePage from '../pages/MitPasswordChangePage.vue';
import MitPasswordForgotPage from '../pages/MitPasswordForgotPage.vue';
import MitPasswordResetFromLinkPage from '../pages/MitPasswordResetFromLinkPage.vue'

import MitMerakiPasswordChangePage from '../pages/MitMerakiPasswordChangePage.vue';

import MitMapsPage from '../pages/MitMapsPage.vue';

import MitEquipmentPage from '../pages/MitEquipmentPage.vue';

import MitKeysPage from '../pages/MitKeysPage.vue';

import MitMyReservationsPage from '../pages/MitMyReservationsPage.vue';

import MitAdminPage from '../pages/admin/MitAdminPage.vue';
import MitAdminEquipmentPage from '../pages/admin/MitAdminEquipmentPage.vue';
import MitAdminGenerateResetLinkPage from '../pages/admin/MitAdminGenerateResetLinkPage.vue';
import MitAdminMonitorPage from '../pages/admin/MitAdminMonitorPage.vue';
import MitAdminSettingsPage from '../pages/admin/MitAdminSettingsPage.vue';

import MitEmailPage from '../pages/MitEmailPage.vue';
import MitStoragePage from '../pages/MitStoragePage.vue';
import MitNetworkPage from '../pages/MitNetworkPage.vue';
import MitDocumentsPage from '../pages/MitDocumentsPage.vue';
import MitComputingPage from '../pages/MitComputingPage.vue';
import MitEventsPage from '../pages/MitEventsPage.vue';
import MitMyEventsPage from '../pages/MitMyEventsPage.vue';

export const defaultRoute = 'accounts';

export function getAppRoutes(MitUserModel, routerGuardAccessCheck) {
  return [
    {
      path: '/landing',
      name: 'landing',
      component: MitLandingPage
    },
    {
      path: '/password/forgot',
      name: 'pass-forgot',
      component: MitPasswordForgotPage,
      props: true
    },
    {
      path: '/password/reset',
      name: 'pass-reset',
      component: MitPasswordResetFromLinkPage,
      props: true
    },
    {
      path: '/accounts',
      name: 'accounts',
      component: MitMyAccountPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/wifi/password/change',
      name: 'wifi-pass-change',
      component: MitMerakiPasswordChangePage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/password/change',
      name: 'pass-change',
      component: MitPasswordChangePage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/email',
      name: 'email',
      component: MitEmailPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/maps',
      name: 'maps',
      component: MitMapsPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/storage',
      name: 'storage',
      component: MitStoragePage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/network',
      name: 'network',
      component: MitNetworkPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/computing',
      name: 'computing',
      component: MitComputingPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/equipment',
      name: 'equipment',
      component: MitEquipmentPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/keys',
      name: 'keys',
      component: MitKeysPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/reservations/my',
      name: 'reservations',
      component: MitMyReservationsPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
        path: '/reservations/my/:id',
        name: 'reservations-my-id',
        component: MitMyReservationsPage,
        meta: { allowedRole: MitUserModel.ROLES.USER },
        props: true,
        beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
        }
    },
    {
      path: '/documents',
      name: 'documents',
      component: MitDocumentsPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/events',
      name: 'events',
      component: MitEventsPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/myEvents',
      name: 'my events',
      component: MitMyEventsPage,
      meta: { allowedRole: MitUserModel.ROLES.USER },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: MitAdminPage,
      meta: { allowedRole: MitUserModel.ROLES.ADMIN },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/admin/equipment',
      name: 'admin-equipment',
      component: MitAdminEquipmentPage,
      meta: { allowedRole: MitUserModel.ROLES.ADMIN },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/admin/reset/link',
      name: 'reset-link',
      component: MitAdminGenerateResetLinkPage,
      meta: { allowedRole: MitUserModel.ROLES.ADMIN },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/admin/activity',
      name: 'admin-activity',
      component: MitAdminMonitorPage,
      meta: { allowedRole: MitUserModel.ROLES.ADMIN },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    },
    {
      path: '/admin/settings',
      name: 'admin-settings',
      component: MitAdminSettingsPage,
      meta: { allowedRole: MitUserModel.ROLES.ADMIN },
      props: true,
      beforeEnter(to, from, next) {
          routerGuardAccessCheck(to, from, next);
      }
    }
    
  ];
}
